<template>
  <li>
    <div class="row">
      <div class="col-xs-6 col-md-9">
        <router-link :to="{ name: 'managers.profile.show', params: { id: staffUser.id } }">
          <div class="details">
            <h3>{{ staffUser.name }}</h3>
          </div>
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3 text-right">
        <toggle-button
          :sync="true"
          v-model="activated"
          class="checkbox"
          :width="120"
          :height="25"
          :labels="{ checked: 'Activated', unchecked: 'Deactivated' }"
          :color="{ checked: $brandPrimary, unchecked: '#b7b7b7' }"/>
      </div>
    </div>
  </li>
</template>

<style scoped>
.vue-js-switch {
  font-size: 13px;
  text-transform: uppercase;
}
</style>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    staffUser: {
      required: true,
      type: Object
    }
  },

  computed: {
    activated: {
      get () {
        return this.staffUser.status === 'active'
      },

      set (value) {
        if (value) {
          this.activateManagerStaffUser(this.staffUser.id)
        } else {
          this.deactivateManagerStaffUser(this.staffUser.id)
        }
      }
    }
  },

  methods: {
    ...mapActions('manager/staff', ['activateManagerStaffUser', 'deactivateManagerStaffUser'])
  }
}
</script>
